import { atom } from 'jotai'
import { DataPoint } from '@app/components/Molecules/Charts/ProjectedRiskChart/ProjectedRiskChart'

export interface ProjectedRiskChartSeriesData {
  data: DataPoint[]
  parameter: string
  vulnerabilityList: string[]
  parameterTitle: string
  parameterUnit: string
  yAxisTitle: string
  xAxisMode: 'ari' | 'aep'
}

export interface ProjectedRiskChartDataForRisk {
  riskCurves?: ProjectedRiskChartSeriesData
  projectedConsequence?: ProjectedRiskChartSeriesData
}

export interface ProjectedRiskChartDataState {
  [assetId: string]: {
    [hazardId: string]: ProjectedRiskChartDataForRisk
  }
}

export const projectedRiskChartDataAtom = atom<ProjectedRiskChartDataState>({})

projectedRiskChartDataAtom.debugLabel = 'projectedRiskChartDataAtom'
